import { capitalizeFirstLetter } from "../helpers/helpers";
import { iconsList } from "./icons";

export const CcIcon = ({ name }) => {
  if (name === "NoIcon") return null;
  return iconsList.find((icon) => icon.label === capitalizeFirstLetter(name)).code;
};
